
import ReactHTMLTableToExcel from "react-html-table-to-excel"

export const SewerageWorkTypeExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '45%' }}>

                <h5><span>&emsp;</span></h5>

                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={2} style={{ textAlign: 'center', fontSize: 16 }}>
                        {name}
                    </th>
                </tr>
                {/* <tr><td></td></tr> */}

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th style={{ borderRight: "1px solid black" }}>Work Type</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => (
                            <tr style={{ width: '100%', border: "1px solid black" }}>
                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                <td style={{ textAlign: "center" }}>{item.workType ? item.workType : '-'}</td>
                            </tr>
                        )) :
                        <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}